import { api, ApiRequestConfig } from 'api';
import { State, Store } from 'store/types';
import { GlobalEvents } from '../global';
import { FETCH_SITEMAP } from './sitemap-constants';
import { SitemapRequestResponse } from './sitemap-types';

/**
 * Запрос загрузки списка сервисов
 * @param {string} regionId
 * @param {string} pageUrl
 * @param {number} pageNumber
 * @param {ApiRequestConfig} config
 * @returns {Promise<SitemapRequestResponse>}
 */
export const requestSitemap = (
  regionId: string,
  pageUrl: string,
  pageNumber: number,
  { orchestratorHost, useCredentials, apiKey, requestID }: ApiRequestConfig,
): Promise<SitemapRequestResponse> => {
  return api.get<SitemapRequestResponse>(
    'get-sitemap',
    { regionId, pageUrl, pageNumber: pageNumber.toString() },
    { orchestratorHost, useCredentials, apiKey, requestID }
  );
};

/**
 * Экшен запроса загрузки списка сервисов
 * @param {Store} store
 * @returns {Promise<State>}
 */
export const loadSitemapAction = (store: Store): Promise<State> =>
  new Promise<State>(resolve => {
    const { modelJson } = store.get();
    if (!modelJson.model) {
      resolve(store.get());
      return;
    }

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      apiKey: process.env.API_KEY,
    });

    store.dispatch(FETCH_SITEMAP.init);

    const unsub = store.on('@dispatch', state => {
      if (state.sitemap?.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
